import api from './api';

// 로또 목록 조회
export const getLottos = async () => {
  const response = await api.get('/lotto');
  return response.data;
};

// 로또 생성 (관리자)
export const createLotto = async (date: Date, maxSlots: number) => {
  const response = await api.post('/lotto', {
    date: date.toISOString(),
    maxSlots,
  });
  return response.data;
};

// 로또 신청
export const applyLotto = async (lottoId: string, reason: string) => {
  const response = await api.post(`/lotto/${lottoId}/apply`, {
    reason,
  });
  return response.data;
};

// 로또 추첨 (관리자)
export const drawLotto = async (lottoId: string) => {
  const response = await api.post(`/lotto/${lottoId}/draw`);
  return response.data;
};

// 로또 삭제 (관리자)
export const deleteLotto = async (lottoId: string) => {
  const response = await api.delete(`/lotto/${lottoId}`);
  return response.data;
};
